import type { IHttpApiParameterAndIsCommon } from '@/services/http-api/httpApi';
import type { IWebSocketApiParameterAndIsCommon } from '@/services/websocket-api/webSocketApi';
import { AppJsonSchema2JsonSchemaStandard } from '@tarslib/utils/lib/json-schema/AppJsonSchema2JsonSchemaStandard';
import { ParameterTypeSchema } from '@tarslib/utils/lib/json-schema/ParameterTypeSchema';
import type { JSONSchema7Definition } from 'json-schema';

export function parameterConvertToSchema(
  items: (IHttpApiParameterAndIsCommon | IWebSocketApiParameterAndIsCommon)[],
  definitions: Record<string, JSONSchema7Definition> | undefined,
  appNameLower: string,
) {
  const xAppOrdersKey = `x-${appNameLower}-orders`;
  const schema: any = {
    type: 'object',
    properties: {},
    required: [],
    [xAppOrdersKey]: [],
    definitions,
  };

  items.forEach((res) => {
    const { name, required } = res;

    const properties = ParameterTypeSchema.parameterToDocViewSchema(res);

    if (required) {
      schema.required?.push(name);
    }

    if (schema.properties && !schema[xAppOrdersKey].includes(name)) {
      schema.properties[name] = properties;
      schema[xAppOrdersKey].push(name);
    }
  });

  const result = AppJsonSchema2JsonSchemaStandard(schema, [], {
    enableXAppEnum: true,
    enableXAppMock: true,
  });

  return result;
}
